"use strict";

var _classCallCheck = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var resolve_1 = require("./resolve");

var MissingRefError = /*#__PURE__*/function (_Error) {
  _inherits(MissingRefError, _Error);

  var _super = _createSuper(MissingRefError);

  function MissingRefError(baseId, ref, msg) {
    var _this;

    _classCallCheck(this, MissingRefError);

    _this = _super.call(this, msg || "can't resolve reference ".concat(ref, " from id ").concat(baseId));
    _this.missingRef = resolve_1.resolveUrl(baseId, ref);
    _this.missingSchema = resolve_1.normalizeId(resolve_1.getFullPath(_this.missingRef));
    return _this;
  }

  return MissingRefError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.default = MissingRefError;